/* eslint-disable */
import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify';
import SelectField from '../selectField';

// helpers
import { getDomainNames } from '../../helpers/general'
import { makeSendReActivationEmailDTO } from './sendReActivationEmail.helpers';

import { sendReActivationEmail } from '../../services/user';
import styles from './sendReActivationEmail.module.scss'

import { useTranslation } from 'react-i18next';

const SendReActivationEmail = ({ showModal, handleClose, userId, userEmail }) => {
  const [domainName, setDomainName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useTranslation()

  const setAsSubmitted = () => setIsSubmitting(false);

  const handleSendReActivationEmailSuccess = () => {
    toast.success(t('re-activation-email-sent-successfully'))
    handleClose();
  };

  const handleSendReActivationEmailFailure = (err) => {
    toast.error(err.message)
  };

  const handleSendReActivationEmail = () => {
    const sendReActivationEmailDTO = makeSendReActivationEmailDTO(domainName);
    setIsSubmitting(true)
    sendReActivationEmail(sendReActivationEmailDTO, userId)
      .then(handleSendReActivationEmailSuccess)
      .catch(handleSendReActivationEmailFailure)
      .finally(setAsSubmitted);
  };

  const handleDomainNameChange = (event) => {
    event?.stopPropagation();
    const { value } = event?.target || {};
    setDomainName(value);
  };

  return (
    <Dialog open={showModal} onClose={handleClose} onClick={(e) => e.stopPropagation()}>
      <DialogTitle className={styles.heading}>
        {t('re-activation-title')}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          className={styles.iconBtn}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={styles.container}>
        <div className={styles.msg}>
          {`${t('re-activation-email-will-send-to')} ${userEmail}`}<br />
          {t('re-activation-continue')}
        </div>
        <SelectField
          options={getDomainNames()}
          label={t('re-activation-send-email-through')}
          id="domainName"
          value={domainName}
          error=""
          onChange={handleDomainNameChange}
        />
      </DialogContent>
      <DialogActions className={styles.actions}>
        <Button
          onClick={handleClose}
          type="submit"
          className={styles.cancelBtn}
          variant="contained"
          disabled={isSubmitting}
        >
          {t('reset-password-cancel')}
        </Button>
        <Button
          onClick={handleSendReActivationEmail}
          type="submit"
          className={styles.continueBtn}
          variant="contained"
          disabled={isSubmitting || !domainName}
        >
          {t('reset-password-continue-to-send')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendReActivationEmail;
